// Traduce a copy amigable un mensaje de error crudo del backend de vinculación.
// Es el atajo "solo string" sobre `resolveBindError` (la única lógica de mapeo);
// preserva '' para que los callers apliquen su propio fallback.

import { resolveBindError } from './bindErrors';

export const mapLinkingError = (message: string | null | undefined): string =>
	message ? resolveBindError(undefined, message).message : '';
